import React from 'react';
import { Typography } from '@beeline.com/bp-design-system';
import styled from 'styled-components';
import { DrawerSummaryItem } from 'common/drawer/SummaryItemView';
import { RateCardComplexRateModel, RateCardModel } from '@utmost.co/enterprise-models';
import { RATE_CARD_FREQUENCY } from 'src/components/pages/frontdoor/forms/AddRateCard/RateCard.constants';
import { useRateCardsIntl } from '../translations/useRateCardsIntl';
import SectionLabel from './SectionLabel';
interface Props {
  rateCard?: RateCardModel;
}
// A utility function to format the rate details as a short, human readable string
const getRateItemDetails = (rate: RateCardComplexRateModel) => {
  let details: string = '-';
  if (rate.formula) {
    details = `${rate.formula.multiplier} x ${rate.formula.baseRateCode}`;
  } else if (rate.static) {
    details = `${rate.static.amount} ${rate.static.currency} / ${RATE_CARD_FREQUENCY.find((r) => r.value === rate.static.frequency)?.label ?? '-'}`;
  }
  return details;
};
export const RatesSummary: React.FC<React.PropsWithChildren<Props>> = ({ rateCard }) => {
  const intl = useRateCardsIntl();
  const hasRates = (rateCard?.rates?.items?.length ?? 0) > 0;
  return (
    <div data-test="drawer-summary">
      <SectionLabel>{intl.rates}</SectionLabel>
      <StyledDiv data-test="summary-rates-container">
        {hasRates ? (
          rateCard?.rates?.items?.map((rate) => (
            <DrawerSummaryItem
              rightAlign
              columnSplit={{ left: 0.5, right: 0.5 }}
              key={rate.name}
              label={`${rate.name} (${rate.code})`}
              loading={false}
              dataTest="rate-item"
            >
              {getRateItemDetails(rate)}
            </DrawerSummaryItem>
          ))
        ) : (
          <StyledEmpty dataTest="empty-rates-summary">{intl.noRates}</StyledEmpty>
        )}
      </StyledDiv>
    </div>
  );
};
const StyledDiv = styled.div`
  width: 33rem;
`;
const StyledEmpty = styled(Typography)`
  color: ${({ theme }) => theme.colorOnSurfaceVariant};
`;
